import * as React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './bread.css';

export interface IBreadCrumbProps {
  history: any;
}

class BreadCrumb extends React.Component<IBreadCrumbProps> {
  getCrumbsFromHistory = () => {
    let bread;
    if (this.props.history) {
      switch (this.props.history.location.pathname) {
        case '/Dashboard':
          bread = (
            <Breadcrumb className='bread'>
              <Breadcrumb.Item active>Dashboard</Breadcrumb.Item>
            </Breadcrumb>
          );
          break;
        case '/KeywordQueue':
          bread = this.bakeBread([
            { display: 'Keywords', path: '/KeywordQueue', active: true },
          ]);
          break;
        case '/Keywords':
          bread = this.bakeBread([
            { display: 'Keywords', path: '/KeywordQueue', active: false },
            { display: 'Keyword Entry', path: '/Keywords', active: true },
          ]);
          break;
        case '/DataTranscribeQueue':
          bread = this.bakeBread([
            { display: 'Transcriber', path: '/DataTranscribeQueue', active: true },
          ]);
          break;
        case '/DataTranscriber':
          bread = this.bakeBread([
            {
              display: 'Transcriber',
              path: '/DataTranscribeQueue',
              active: false,
            },
            {
              display: 'Data Transcription',
              path: '/DataTranscriber',
              active: true,
            },
          ]);
          break;
        case '/DataTranscriberValidationQueue':
          bread = this.bakeBread([
            { display: 'Transcriber Validation', path: '/DataTranscriberValidationQueue', active: true },
          ]);
          break;
        case '/DataTranscriberValidation':
          bread = this.bakeBread([
            {
              display: 'Transcriber Validation',
              path: '/DataTranscriberValidationQueue',
              active: false,
            },
            {
              display: 'Transcription Validation',
              path: '/DataTranscriberValidation',
              active: true,
            },
          ]);
          break;
        case '/DataEntryQueue':
          bread = this.bakeBread([
            { display: 'Data Entry', path: '/DataEntryQueue', active: true },
          ]);
          break;
        case '/DataEntryForm':
          bread = this.bakeBread([
            {
              display: 'Data Entry',
              path: '/DataEntryQueue',
              active: false,
            },
            {
              display: 'Data Entry',
              path: '/DataEntryForm',
              active: true,
            },
          ]);
          break;
        case '/CheckerReview':
          bread = this.bakeBread([
            {
              display: 'Checkers',
              path: '/Checkers',
              active: false,
            },
            {
              display: 'Checkers Review',
              path: '/CheckerReview',
              active: true,
            },
          ]);
          break;
        case '/ManageReport':
          bread = this.bakeBread([
            {
              display: 'Management',
              path: '/ManagementQueue',
              active: false,
            },
            {
              display: 'Manage Report',
              path: '/ManageReport',
              active: true,
            },
          ]);
          break;
        case '/PowerBiReports':
          bread = this.bakeBread([
            {
              display: 'Power BI Reports',
              path: '/PowerBiReports',
              active: true,
            },
          ]);
          break;
        case '/ManageFARs':
          bread = this.bakeBread([
            {
              display: 'Manage FARs',
              path: '/ManageFARs',
              active: true,
            },
          ]);
          break;
        case '/ViewReport':
          bread = this.bakeBread([
            {
              display: 'Power BI Reports',
              path: '/PowerBiReports',
              active: false,
            },
            {
              display: 'View Report',
              path: '/ViewReport',
              active: true,
            },
          ]);
          break;
        case '/EditReport':
          bread = this.bakeBread([
            {
              display: 'Power BI Reports',
              path: '/PowerBiReports',
              active: false,
            },
            {
              display: 'Edit Report',
              path: '/EditReport',
              active: true,
            },
          ]);
          break;
        case '/CreateReport':
          bread = this.bakeBread([
            {
              display: 'Power BI Reports',
              path: '/PowerBiReports',
              active: false,
            },
            {
              display: 'Create Report',
              path: '/CreateReport',
              active: true,
            },
          ]);
          break;
        default:
          const show = this.props.history.location.pathname
            .replace('/', '')
            .replace(/([A-Z])/g, ' $1')
            .trim();
          bread = this.bakeBread([
            {
              display: show,
              path: this.props.history.location.pathname,
              active: true,
            },
          ]);
          break;
      }
      return bread;
    } else {
      return 'cant read history';
    }
  };

  bakeBread = (crumbs: any[]) => {
    let items: any[] = [
      <Breadcrumb.Item
        key='dashboard'
        linkProps={{ to: '/Dashboard' }}
        linkAs={Link}
      >
        Home
      </Breadcrumb.Item>,
    ];
    crumbs.forEach((crumb) => {
      if (crumb.active)
        items.push(
          <Breadcrumb.Item active key={crumb.path}>
            {crumb.display}
          </Breadcrumb.Item>
        );
      else {
        items.push(
          <Breadcrumb.Item
            key={crumb.path}
            linkProps={{ to: crumb.path }}
            linkAs={Link}
          >
            {crumb.display}
          </Breadcrumb.Item>
        );
      }
    });

    const bread = (
      <Breadcrumb className='bread'>
        {items.map((x) => {
          return x;
        })}
      </Breadcrumb>
    );
    return bread;
  };

  public render() {
    const bread = this.getCrumbsFromHistory();
    return <div>{bread}</div>;
  }
}

const mapStateToProps = (reduxState: any) => {
  return {};
};

const mapDispatchToProps = {};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BreadCrumb)
);
